import React, { useState, useEffect, createContext } from 'react';
import { ServerURL } from '../../../serverURL';
import { useAuthCheck } from '../../../context/authkeyCheck';

const WebSocketContext = createContext();

export const CompanyWebSocketProvider = ({ children }) => {  
    const {isCompanyAuthenticated} = useAuthCheck(); 
    const [chatSocket, setChatSocket] = useState(null);

    useEffect(() => {
        let socket;
        let reconnectTimeout;
        const ChatUserId = localStorage.getItem("ChatUserId");
        const ChatUserConnection = sessionStorage.getItem("ChatUserConnection");

        // Function to initialize WebSocket connection
        const connectWebSocket = () => {
            const wsUrl = `wss://${ServerURL.WEBSOCKET_HOST_URL}/ws/chat/${localStorage.getItem('ChatUserId')}/`;
            socket = new WebSocket(wsUrl);
            setChatSocket(socket);

            // WebSocket event listeners
            socket.onopen = () => {
                console.log('Company WebSocket Connected.');
                setChatSocket(socket);
                sessionStorage.setItem("ChatUserConnection", true);
            };

            socket.onclose = () => {
                sessionStorage.setItem("ChatUserConnection", false);
                console.log('Company WebSocket connection closed, attempting to reconnect in 1 second');
                // Attempt to reconnect after 1 second
                reconnectTimeout = setTimeout(() => {
                    connectWebSocket();
                }, 1000);
            };

            socket.onerror = (error) => {
                console.error('Company WebSocket error:', error);
            };
        };

        // Initial WebSocket connection
        if(isCompanyAuthenticated && ChatUserId && ChatUserConnection === 'false'){
            connectWebSocket();
        }        

        // Cleanup function
        return () => {
            if (socket) socket.close();
            clearTimeout(reconnectTimeout);
        };
    }, [isCompanyAuthenticated]);

    return (
        <WebSocketContext.Provider value={{ chatSocket }}>
            {children}
        </WebSocketContext.Provider>
    );
};

export const useWebSocket = () => {
    return React.useContext(WebSocketContext);
};
